// JKHive-flavored Menu — reuses the admin-menu page component
// inside the JKHive layout.
import React from 'react';
import AdminMenu from '../admin-menu';

const JKHiveMenu = () => <AdminMenu />;
export default JKHiveMenu;
